import { defineStore } from "pinia";
import { ref } from "vue";

export const useSettingsStore = defineStore("settings", () => {
   const lazyLoadEnabled = ref(true);

   const setLazyLoad = async (value: boolean) => {
      lazyLoadEnabled.value = value;
   };

   return { lazyLoadEnabled, setLazyLoad };
});
